var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.672,
    height: 23.672,
    viewBox: "0 0 23.672 23.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9411",
    "data-name": "Path 9411",
    d: "M10.986,21.781a1.972,1.972,0,0,0,1.973,1.973H20.85a1.972,1.972,0,0,0,1.973-1.973V9.945H10.986ZM23.809,6.986H20.356L19.37,6H14.438l-.986.986H10V8.959H23.809Z",
    transform: "translate(-5.068 -3.041)",
    fill: "#6c757d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9412",
    "data-name": "Path 9412",
    d: "M0,0H23.672V23.672H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLogo);
export default __webpack_public_path__ + "static/media/delete_logo.80d9b48d6ac3fd19939167db57b618ad.svg";
export { ForwardRef as ReactComponent };